import { connect } from 'react-redux';

import type {
  ContainerProps,
  DispatchProps,
  OwnProps,
} from 'src/components/organisms/Personalisation/components/MultipleOptionSelection/MultipleOptionSelection';
import { MultipleOptionSelection } from 'src/components/organisms/Personalisation/components/MultipleOptionSelection/MultipleOptionSelection';
import {
  selectNumberOfRequiredOptions,
  selectOptions,
  selectOutstandingOptions,
  selectSelectedOption,
  selectTrackedEvents,
} from 'src/redux/basket/selectors';
import { actions as basketActions } from 'src/redux/basket/slice';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

const mapStateToProps = (state: ReduxApplicationState, props: OwnProps): ContainerProps => ({
  currency: state.product.price.currency,
  error:
    Boolean(props.displayValidation) &&
    selectOutstandingOptions(state).some((opt) => opt.id === props.id),
  options: selectOptions(state),
  selectedOption: selectSelectedOption(state, props.id),
  totalOutstandingSelections: selectOutstandingOptions(state).length,
  totalRequiredOptions: selectNumberOfRequiredOptions(state),
  trackedEvents: selectTrackedEvents(state),
});

const mapDispatchToProps: DispatchProps = {
  deselectOption: basketActions.deselectOption,
  selectOption: basketActions.selectOption,
  trackInteraction: basketActions.trackInteraction,
  trackInteractionError: basketActions.trackInteractionError,
  trackProgressMilestone: basketActions.trackProgressMilestone,
};

export const MultipleOptionSelectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MultipleOptionSelection);
